<template>
  <section class="perfil">
    <div class="avatar">
      <div class="avatar-wrapper">
        <img src="@/assets/avatar/avatar-profile.svg">
      </div>

      <div class="avatar-options">
        <button class="imagem">
          Imagem
        </button>
        <button class="remover">
          Remover imagem
        </button>
      </div>
    </div>

    <div class="informacoes">
      <div class="container">
        <h2 class="title">
          Informações Pessoais
        </h2>
      </div>

      <div class="form">
        <div class="container">
          <div class="form-group">
            <div class="itemUpdate"> Nome </div>
            <input
              v-model="user.firstName"
              type="text"
              placeholder="Nome"
              :disabled=" isDisable >= 1"
            >
            <div class="itemUpdate"> Sobrenome </div>
            <input
              v-model="user.lastName"
              type="text"
              placeholder="Sobrenome"
              :disabled=" isDisable >= 1"
            >
          </div>
          <div class="form-group">
            <div class="itemUpdate"> Trailer </div>
            <input
              v-model="user.trailer_about"
              type="text"
              placeholder="Profissão"
              :disabled=" isDisable >= 1"
            >
            <div class="itemUpdate"> Telefone </div>
            <input
              v-model="user.phone"
              type="text"
              placeholder="Telefone"
              :disabled=" isDisable >= 1"
            >
          </div>
          <div class="form-group">
            <div class="itemUpdate"> Cidade </div>
            <input
              v-model="user.location"
              type="text"
              placeholder="Cidade"
              :disabled=" isDisable >= 1"
            >
            <div class="itemUpdate"> Sobre </div>
            <input
              v-model="user.about"
              type="email"
              placeholder="sobre"
              :disabled=" isDisable >= 1"
            > 
          </div>
        </div>
      </div>

      <div>
        <div class="container">
          <button @click="updateSubmit">
            Salvar
          </button>
          <button 
            style="background-color: #67C23A; margin-left:10px"
            @click="editInput"
          >
            Editar
          </button>
        </div>
      </div>
    </div>
  </section>
</template>


<script>

import { mapGetters, mapActions } from "vuex"
import axios from 'axios'
import TeacherService from '../../../../../service/TeacherService/TeacherService.js'

const app = new TeacherService();

export default {
  name: "Profile",

  data() {
    return {
      userToUpdate: {},
      user: [],
      isDisable:999
    }
  },

  computed: {
    ...mapGetters('auth', ['resume'])
  },
  async mounted() {
    await this.getUser()
    console.log(this.user)
  },

  methods: {
    ...mapActions('auth', ['update']),

    async getUser() {
      // this.$set(this, "userToUpdate", Object.assign({}, this.resume))
      const id = localStorage.getItem('user');
      const { data } = await axios.get(`${process.env.VUE_APP_API}/user/${id}`);
      this.user = data;
    },

    async updateSubmit() {
      // eslint-disable-next-line no-unused-vars
      let payload = Object.fromEntries(Object.entries(this.user).filter(([_, v]) => v != null && v != ''));

      delete payload.courses; 
      delete payload.createdAt; 
      delete payload.role; 
      delete payload.status; 
      delete payload.updatedAt;
      console.log(payload);

      await app.update(payload)
    },
    editInput(){
      if(this.isDisable > 0){
        this.isDisable = 0;
      }
      else{
        this.isDisable = 999;
      }
    }
  }
}

</script>


<style lang="scss" scoped>

.itemUpdate{
    // margin: auto;
    padding: 8px;
    font-size: 20px;
}

.perfil {
    .avatar {
        background: #fff;
        padding: 16px 24px 10px 24px;
        // display: ;
        flex-direction: column;
        box-shadow: 0px 0px 0px 1px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15);
        border-radius: 4px;

        .avatar-wrapper {
            background: #041586;
            width: 156px;
            height: 156px;
            // display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 16px;
            border-radius: 4px;
        }

        .avatar-options {
            border-top: 1px solid #E4E7EB;
            // display: flex;
            padding-top: 10px;

            .imagem {
                color: white;
                background: #1D43FF;
                border: none;
                font-size: 0.875;
                padding: 12px 48px;
                border-radius: 4px;
                font-weight: 700;
            }

            .remover {
                background: transparent;
                color: #425A70;
                margin-left: 33px;
                border: none;
            }
        }
    }

    .informacoes {
        background: #fff;
        margin-top: 24px;
        box-shadow: 0px 0px 0px 1px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15);
        border-radius: 4px;
        // padding-bottom: 24px;

        .container {
            max-width: 910px;
            margin: 0 auto;
            padding-bottom:1rem;

            .title {
                padding: 26px 0;
                color: #3A3B3F;
                font-size: 1rem;
            }

            button {
                color: white;
                background: #1D43FF;
                border: none;
                font-size: 0.875;
                padding: 12px 48px;
                border-radius: 4px;
                font-weight: 700;
                // margin-top: 24px;
            }

            .form-group {
                // padding: 1rem 0;
                // display: flex;

                input, select {
                    width: 70%;
                    padding: 16px;
                    font-family: 'Roboto' sans-serif;
                    border: 1px solid rgba(0, 0, 0, 0.32);
                    border-radius: 4px;
                    margin-right: 24px;
                }

                .city {
                    margin: 0;
                    margin-right: 24px;
                }
            }
        }

        .form {
            border-top: 1px solid #E4E7EB;
            border-bottom: 1px solid #E4E7EB;
        }
    }

}

@media (max-width: 768px) {
  .perfil {
      .informacoes {
          padding-bottom: 0;

          .container {
              padding: 18px 14px;
              
              button {
                  width: 100%;
                  margin-top: 0;
              }
              .form-group {
                  // flex-direction: column;
                  padding: 0;
      
                  input,
                  select {
                      margin: auto;
                      // margin-bottom: 30px;
                      width: 100%;
                  }

                  input[type="email"] {
                      // margin-bottom: 0;
                  }

                  .city {
                      margin: auto;
                      // margin-bottom: 30px;
                  }
              }
          }
      }
  }
}
</style>